import { render, staticRenderFns } from "./ExibirCessao.vue?vue&type=template&id=2cdffd59&scoped=true&"
import script from "./ExibirCessao.vue?vue&type=script&lang=js&"
export * from "./ExibirCessao.vue?vue&type=script&lang=js&"
import style0 from "./ExibirCessao.vue?vue&type=style&index=0&id=2cdffd59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdffd59",
  null
  
)

export default component.exports